<template>
    <div class="safety-datasheet"
         v-if="final_classification"
    >
        <div class="content-grid">
            <div class="left-column">
                <div class="section-card pictograms-section">
                    <div class="section-header">
                        <div class="classification-header-icon classification-warning-icon">
                            <i class="fa fa-exclamation-triangle"></i>
                        </div>
                        <div class="header-text">
                            <h3 class="section-title">PICTOGRAMAS</h3>
                        </div>
                    </div>
                    <div class="section-content">
                        <div class="pictograms-container">
                            <div
                                v-for="(pictogram, index) in final_classification.final_pictograms"
                                :key="index"
                                class="pictogram-item"
                                v-b-tooltip.hover
                            >
                                <div class="pictogram-icon">
                                    <img :src="pictogram" alt="pictogram" width="80"/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="section-card warning-section" v-if="final_classification.warning_word">
                    <div class="section-header">
                        <div class="classification-header-icon danger-icon">
                            <i class="fa fa-exclamation-circle"></i>
                        </div>
                        <div class="header-text">
                            <h3 class="section-title">PALABRA DE ADVERTENCIA</h3>
                        </div>
                    </div>
                    <div class="section-content">
                        <div class="warning-display">
                            <span class="warning-word">{{ final_classification.warning_word }}</span>
                        </div>
                    </div>
                </div>

                <div class="section-card classification-section">
                    <div class="section-header">
                        <div class="classification-header-icon danger-icon">
                            <i class="fa fa-tags"></i>
                        </div>
                        <div class="header-text">
                            <h3 class="section-title">CLASES Y CATEGORÍAS DE PELIGROS</h3>
                        </div>
                    </div>
                    <div class="section-content">
                        <div class="classification-list">
                            <div
                                v-for="(category, index) in final_classification.categories"
                                :key="index"
                                class="classification-item"
                            >
                                <div class="classification-main">
                                    <span class="category-name">{{ category.category }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="section-card hazard-section">
                    <div class="section-header">
                        <div class="classification-header-icon classification-warning-icon">
                            <i class="fa fa-list-alt"></i>
                        </div>
                        <div class="header-text">
                            <h3 class="section-title">INDICACIONES DE PELIGRO</h3>
                        </div>
                    </div>
                    <div class="section-content">
                        <div class="statements-list">
                            <div
                                v-for="(statement, index) in final_classification.hazard_statements"
                                :key="index"
                                class="statement-item"
                            >
                                <div class="statement-header">
                                    <span class="statement-code">{{ statement.code }}</span>
                                    <span class="statement-text">{{ statement.description }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="right-column">
                <div class="precautionary-container">
                    <div class="precautionary-header">
                        <b-btn variant="info"
                               class="float-right ml-4 text-white"
                               size="sm"
                               @click="downloadFinalClassification"
                        >
                            <i class="fa fa-file-pdf-o text-white"/>
                            Descargar
                        </b-btn>
                        <h2 class="precautionary-title">
                            <i class="fa fa-shield"></i>
                            Consejos de Prudencia
                        </h2>
                    </div>

                    <div class="advice-grid">
                        <div class="advice-card general-card general-full-width">
                            <div class="advice-header">
                                <div class="advice-icon general-icon">
                                    <i class="fa fa-info"></i>
                                </div>
                                <div class="advice-title">
                                    <h4>Generales</h4>
                                </div>
                            </div>
                            <div class="advice-content">
                                <div
                                    v-for="(advice, index) in final_classification.general"
                                    :key="index"
                                    class="advice-item"
                                >
                                    <span class="advice-code general-code"
                                          :style="advice.code.length > 10 ? 'font-size: 9px' : (advice.code.length > 4 ? 'font-size: 10px' : '')"
                                    >
                                        {{ advice.code }}
                                    </span>
                                    <span class="advice-text">{{ advice.description }}</span>
                                </div>
                            </div>
                        </div>

                        <div class="advice-card prevention-card">
                            <div class="advice-header">
                                <div class="advice-icon prevention-icon">
                                    <i class="fa fa-hand-stop-o"></i>
                                </div>
                                <div class="advice-title">
                                    <h4>Prevención</h4>
                                </div>
                            </div>
                            <div class="advice-content">
                                <div
                                    v-for="(advice, index) in final_classification.precautionary_advice"
                                    :key="index"
                                    class="advice-item"
                                >
                                    <span class="advice-code prevention-code"
                                          :style="advice.code.length > 10 ? 'font-size: 9px' : (advice.code.length > 4 ? 'font-size: 10px' : '')"
                                    >
                                        {{ advice.code }}
                                    </span>
                                    <span class="advice-text">{{ advice.description }}</span>
                                </div>
                            </div>
                        </div>

                        <div class="advice-card intervention-card">
                            <div class="advice-header">
                                <div class="advice-icon intervention-icon">
                                    <i class="fa fa-medkit"></i>
                                </div>
                                <div class="advice-title">
                                    <h4>Intervención</h4>
                                </div>
                            </div>
                            <div class="advice-content">
                                <div
                                    v-for="(advice, index) in final_classification.intervention_advice"
                                    :key="index"
                                    class="advice-item"
                                >
                                    <span class="advice-code intervention-code"
                                          :style="advice.code.length > 10 ? 'font-size: 9px' : (advice.code.length > 4 ? 'font-size: 10px' : '')"
                                    >
                                        {{ advice.code }}
                                    </span>
                                    <span class="advice-text">{{ advice.description }}</span>
                                </div>
                            </div>
                        </div>

                        <div class="advice-card storage-card">
                            <div class="advice-header">
                                <div class="advice-icon storage-icon">
                                    <i class="fa fa-archive"></i>
                                </div>
                                <div class="advice-title">
                                    <h4>Almacenamiento</h4>
                                </div>
                            </div>
                            <div class="advice-content">
                                <div
                                    v-for="(advice, index) in final_classification.storage"
                                    :key="index"
                                    class="advice-item"
                                >
                                    <span class="advice-code storage-code"
                                          :style="advice.code.length > 10 ? 'font-size: 9px' : (advice.code.length > 4 ? 'font-size: 10px' : '')"
                                    >
                                        {{ advice.code }}
                                    </span>
                                    <span class="advice-text">{{ advice.description }}</span>
                                </div>
                            </div>
                        </div>

                        <div class="advice-card disposal-card">
                            <div class="advice-header">
                                <div class="advice-icon disposal-icon">
                                    <i class="fa fa-recycle"></i>
                                </div>
                                <div class="advice-title">
                                    <h4>Eliminación</h4>
                                </div>
                            </div>
                            <div class="advice-content">
                                <div
                                    v-for="(advice, index) in final_classification.elimination"
                                    :key="index"
                                    class="advice-item"
                                >
                                    <span class="advice-code disposal-code"
                                          :style="advice.code.length > 10 ? 'font-size: 9px' : (advice.code.length > 4 ? 'font-size: 10px' : '')"
                                    >
                                        {{ advice.code }}
                                    </span>
                                    <span class="advice-text">{{ advice.description }}</span>
                                </div>
                                <div class="disposal-note">
                                    <i class="fa fa-info-circle"></i>
                                    <small>Según normativas locales, regionales, nacionales e
                                        internacionales</small>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {mapState, mapActions} from 'vuex'

export default {
    name: 'ModernSafetyDatasheet',
    async mounted() {
        const product_id = this.$route.params.product_id;
        const company_id = this.$route.params.company_id;

        await this.getFinalClassifications({product_id, company_id});

        window.addEventListener('resize', this.handleGridLayout);
        this.$nextTick(() => {
            this.handleGridLayout();
        });
    },

    beforeDestroy() {
        window.removeEventListener('resize', this.handleGridLayout);
    },

    computed: {
        ...mapState('calculator', [
            'final_classification'
        ])
    },
    methods: {
        ...mapActions('calculator', [
            'getFinalClassifications',
            'downloadFinalClassification'
        ]),
        handleGridLayout() {
            this.$nextTick(() => {
                const grid = this.$el.querySelector('.advice-grid');
                if (!grid) return;

                const cards = grid.querySelectorAll('.advice-card:not(.general-full-width)');
                if (cards.length === 0) return;

                cards.forEach(card => card.classList.remove('expand-full-width'));

                const gridStyle = window.getComputedStyle(grid);
                const gridWidth = grid.offsetWidth;
                const gap = parseInt(gridStyle.gap) || 6;
                const minWidth = 350;

                const columnsPerRow = Math.floor((gridWidth + gap) / (minWidth + gap));

                if (columnsPerRow > 1) {
                    const totalCards = cards.length;
                    const lastRowCards = totalCards % columnsPerRow;

                    if (lastRowCards === 1) {
                        const lastCard = cards[cards.length - 1];
                        lastCard.classList.add('expand-full-width');
                    }
                }
            });
        }
    }
}
</script>

<style>

:root {
    --primary-color: #2c3e50;
    --secondary-color: #3498db;
    --accent-color: #e74c3c;
    --success-color: #27ae60;
    --warning-color: #f39c12;
    --info-color: #3498db;
    --danger-color: #e74c3c;
    --light-gray: #f8f9fa;
    --medium-gray: #020202;
    --dark-gray: #495057;
    --border-color: #dee2e6;
    --shadow-light: 0 2px 4px rgba(0, 0, 0, 0.04);
    --shadow-medium: 0 4px 12px rgba(0, 0, 0, 0.08);
    --shadow-strong: 0 8px 24px rgba(0, 0, 0, 0.12);
    --border-radius: 12px;
    --border-radius-small: 8px;
    --transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.safety-datasheet {
    margin: 0 auto;
    padding: 16px;
    background: linear-gradient(135deg, #f5f7faab 0%, #c3cfe278 100%);
    min-height: 100vh;
}

.datasheet-header {
    text-align: center;
    margin-bottom: 32px;
    padding: 32px 0;
    background: white;
    border-radius: var(--border-radius);
    box-shadow: var(--shadow-light);
    border: 1px solid var(--border-color);
}

.datasheet-title {
    color: var(--primary-color);
    font-size: 2.5rem;
    font-weight: 700;
    margin-bottom: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 16px;
}

.datasheet-title i {
    color: var(--secondary-color);
    font-size: 2rem;
}

.datasheet-subtitle {
    color: var(--medium-gray);
    font-size: 1.1rem;
    margin: 0;
    font-weight: 400;
}

.content-grid {
    display: grid;
    grid-template-columns: 40% 60%;
    gap: 12px;
    align-items: start;
}

.left-column,
.right-column {
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.section-card {
    background: white;
    border-radius: var(--border-radius);
    box-shadow: var(--shadow-light);
    border: 1px solid var(--border-color);
    overflow: hidden;
    transition: var(--transition);
}

.section-card:hover {
    box-shadow: var(--shadow-medium);
    transform: translateY(-2px);
}

.section-header {
    padding: 20px 24px;
    background: var(--light-gray);
    border-bottom: 1px solid var(--border-color);
    display: flex;
    align-items: center;
    gap: 16px;
}

.classification-header-icon {
    width: 36px;
    height: 36px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 20px;
    color: white;
    flex-shrink: 0;
}

.classification-warning-icon {
    background: linear-gradient(135deg, #f39c12, #e67e22);
}

.danger-icon {
    background: linear-gradient(135deg, #e74c3c, #c0392b);
}

.info-icon {
    background: linear-gradient(135deg, #3498db, #2980b9);
}

.header-text {
    flex: 1;
}

.section-title {
    color: var(--primary-color);
    font-size: 1.2rem;
    font-weight: 600;
    margin: 0 0 4px 0;
}

.section-subtitle {
    color: var(--medium-gray);
    font-size: 0.9rem;
    margin: 0;
    font-weight: 400;
}

.section-content {
    padding: 24px;
}

.pictograms-container {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 20px;
}

.pictogram-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    padding: 16px;
    border-radius: var(--border-radius-small);
    background: var(--light-gray);
    transition: var(--transition);
    cursor: pointer;
    border: 1px solid var(--border-color);
    width: 140px;
}

.pictogram-item:hover {
    transform: translateY(-4px);
    box-shadow: var(--shadow-medium);
    background: white;
}

.pictogram-icon {
    width: 64px;
    height: 64px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 24px;
    color: white;
    box-shadow: var(--shadow-light);
}

.pictogram-label {
    font-size: 0.85rem;
    font-weight: 500;
    color: var(--dark-gray);
    line-height: 1.3;
}

.warning-display {
    text-align: center;
    padding: 10px;
}

.warning-word {
    display: inline-block;
    font-size: 1.2rem;
    font-weight: 600;
    color: var(--danger-color);
    padding: 8px 16px;
    border: 2px solid var(--danger-color);
    border-radius: var(--border-radius);
    background: linear-gradient(135deg, #fff, #ffeaea);
    letter-spacing: 2px;
    text-transform: uppercase;
}

/* Classification */
.classification-list {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.classification-item {
    padding: 8px 12px;
    background: var(--light-gray);
    border-radius: var(--border-radius-small);
    border-left: 4px solid var(--danger-color);
    transition: var(--transition);
}

.classification-item:hover {
    background: white;
    box-shadow: var(--shadow-light);
}

.classification-main {
    display: flex;
    align-items: center;
    gap: 12px;
}

.hazard-code {
    background: var(--danger-color);
    color: white;
    padding: 3px 6px;
    border-radius: 4px;
    font-weight: 600;
    font-size: 0.8rem;
    min-width: 60px;
    text-align: center;
}

.category-name {
    color: var(--primary-color);
}

.sub-category {
    color: var(--medium-gray);
    font-size: 0.85rem;
    font-style: italic;
}

.statements-list {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.statement-item {
    padding: 8px 12px;
    background: var(--light-gray);
    border-radius: var(--border-radius-small);
    border-left: 4px solid var(--warning-color);
    transition: var(--transition);
}

.statement-item:hover {
    background: white;
    box-shadow: var(--shadow-light);
}

.statement-header {
    display: flex;
    align-items: center;
    gap: 12px;
}

.statement-code {
    background: var(--warning-color);
    color: white;
    padding: 3px 6px;
    border-radius: 4px;
    font-weight: 600;
    font-size: 0.8rem;
}

.statement-text {
    color: var(--dark-gray);
    line-height: 1.5;
    margin: 0;
    font-size: 0.9rem;
}

.statement-meta {
    margin-top: 8px;
    padding-top: 8px;
    border-top: 1px solid var(--border-color);
}

.meta-text {
    color: var(--medium-gray);
    font-size: 0.8rem;
    font-style: italic;
}

.precautionary-container {
    grid-column: 1 / -1;
    margin-top: 6px;
    padding: 0 12px;
}

.precautionary-header {
    text-align: center;
    margin-bottom: 24px;
}

.precautionary-title {
    color: var(--primary-color);
    font-size: 1.8rem;
    font-weight: 600;
    margin: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 12px;
}

.precautionary-title i {
    color: var(--success-color);
}

.advice-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
    gap: 6px;
}

.general-full-width,
.expand-full-width {
    grid-column: 1 / -1;
}

.advice-card {
    background: white;
    border-radius: var(--border-radius);
    box-shadow: var(--shadow-light);
    border: 1px solid var(--border-color);
    overflow: hidden;
    transition: var(--transition);
}

.advice-card:hover {
    box-shadow: var(--shadow-medium);
    transform: translateY(-2px);
}

.advice-header {
    padding: 16px 20px;
    background: var(--light-gray);
    border-bottom: 1px solid var(--border-color);
    display: flex;
    align-items: center;
    gap: 12px;
}

.advice-icon {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;
    color: white;
}

.prevention-icon {
    background: linear-gradient(135deg, #27ae60, #229954);
}

.intervention-icon {
    background: linear-gradient(135deg, #3498db, #2980b9);
}

.storage-icon {
    background: linear-gradient(135deg, #f39c12, #e67e22);
}

.disposal-icon {
    background: linear-gradient(135deg, #9b59b6, #8e44ad);
}

.general-icon {
    background: linear-gradient(135deg, #6c757d, #5a6268);
}

.advice-title h4 {
    color: var(--primary-color);
    font-size: 1.1rem;
    font-weight: 600;
    margin: 0;
}

.advice-content {
    padding: 8px 10px;
}

.advice-item {
    display: flex;
    align-items: flex-start;
    gap: 8px;
    margin-bottom: 6px;
    padding: 6px;
    background: var(--light-gray);
    border-radius: var(--border-radius-small);
    transition: var(--transition);
}

.advice-item:hover {
    background: white;
    box-shadow: var(--shadow-light);
}

.advice-item:last-child {
    margin-bottom: 0;
}

.advice-code {
    background: var(--medium-gray);
    color: white;
    padding: 3px 6px;
    border-radius: 4px;
    font-weight: 600;
    font-size: 0.75rem;
    min-width: 65px;
    text-align: center;
    flex-shrink: 0;
}

.prevention-code {
    background: var(--success-color);
}

.intervention-code {
    background: var(--info-color);
}

.storage-code {
    background: var(--warning-color);
}

.disposal-code {
    background: #9b59b6;
}

.general-code {
    background: #6c757d;
}

.advice-text {
    color: var(--dark-gray);
    line-height: 1.5;
    font-size: 12px;
    flex: 1;
}

.disposal-note {
    display: flex;
    align-items: center;
    gap: 8px;
    color: var(--medium-gray);
    font-size: 0.8rem;
    margin-top: 8px;
    padding-top: 8px;
    border-top: 1px solid var(--border-color);
}

.disposal-note i {
    color: var(--info-color);
}

@media (max-width: 1024px) {
    .content-grid {
        grid-template-columns: 1fr;
        gap: 24px;
    }

    .precautionary-container {
        grid-column: 1;
    }
}

@media (max-width: 768px) {
    .safety-datasheet {
        padding: 8px;
    }

    .datasheet-title {
        font-size: 2rem;
        flex-direction: column;
        gap: 8px;
    }

    .pictograms-container {
        justify-content: center;
        gap: 16px;
    }

    .pictogram-item {
        width: 120px;
    }

    .advice-grid {
        grid-template-columns: 1fr;
    }

    .section-content {
        padding: 16px;
    }
}

@media (max-width: 480px) {
    .advice-item {
        flex-direction: column;
        align-items: flex-start;
        gap: 8px;
    }

    .advice-code {
        align-self: flex-start;
    }
}

.section-card {
    animation: fadeInUp 0.5s ease-out;
    animation-fill-mode: both;
}

.section-card:nth-child(1) {
    animation-delay: 0.1s;
}

.section-card:nth-child(2) {
    animation-delay: 0.2s;
}

.section-card:nth-child(3) {
    animation-delay: 0.3s;
}

.section-card:nth-child(4) {
    animation-delay: 0.4s;
}
</style>
